module.exports = __webpack_public_path__ + "img/sv79.42528516.svg";